exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Y8n368KwaGWK-7LtD_O8p{width:300px}html[dir] .Y8n368KwaGWK-7LtD_O8p{background-color:\"[theme:white, default:#ffffff]\"}._1-Vhx4hvWvT3cbnnH4M2kG{-webkit-animation:none!important;animation:none!important}._2dZOi1ThOzAmEGulSE4h5S{max-height:470px;overflow-x:hidden}._3ng3LrgHuggRYgHAQNerXu{height:30px}html[dir=ltr] ._3ng3LrgHuggRYgHAQNerXu{padding-left:12px}html[dir=rtl] ._3ng3LrgHuggRYgHAQNerXu{padding-right:12px}._77CwT1S0TNeZxVWM0fWA5{font-size:12px;font-weight:400;line-height:1;display:inline-block}html[dir] ._77CwT1S0TNeZxVWM0fWA5{padding-top:8px}", ""]);

// exports
exports.locals = {
	"callout": "Y8n368KwaGWK-7LtD_O8p",
	"animationStop": "_1-Vhx4hvWvT3cbnnH4M2kG",
	"scrollContainer": "_2dZOi1ThOzAmEGulSE4h5S",
	"suggestedContactsHeaderBox": "_3ng3LrgHuggRYgHAQNerXu",
	"suggestedContactsText": "_77CwT1S0TNeZxVWM0fWA5"
};